var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hide,
          expression: "hide",
        },
      ],
      staticClass: "benefit",
    },
    [
      _c("div", { staticClass: "benefit__header", on: { click: _vm.toggle } }, [
        _c("div", { staticClass: "benefit__icon" }, [
          _c("img", { attrs: { src: _vm.icon } }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "benefit__title" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "benefit__content",
          class: { "benefit__content--selected": _vm.isOpen },
        },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }